import React, { useContext, useState } from "react";
import "./Offers.scss"
import Button from "../../Global/Button";
import { useEffect } from "react";
import FailurePopUp from "../../Global/FailurePopUp";
import SuccessPopUp from "../../Global/SuccessPopUp";
// import convertOfferToOpportunity from "../../apis/convert-offer-to-opportunity/convert-offer-to-opportunity";
import Modal from "../../Global/Modal";
import DataMapping from "../../context/data-mapping/data-mapping";
import { STOREDATA } from "../../context/data-mapping/action/action.type";
import commonFunctionObject from "../../common-function";
import OkButtonPopUp from "../../Global/OkButtonPopUp";
import PropTypes from 'prop-types';
import CreditScoreServiceObject from "../../services/CreditScore/CreditScoreService";

const Offers = ({ dynamicOffers, getOffers }) => {
    console.log(dynamicOffers)
    const [failurePopUpModal, setFailurePopUpModal] = useState(false);
    const [failurePopUpContent, setFailurePopUpContent] = useState({
        "apiName": "",
        "message": "",
        "errorCode": ""
    })
    const [successPopUpModal, setSuccessPopUpModal] = useState(false);
    const [successPopUpContent, setSuccessPopUpContent] = useState("");
    const [offerpopopen, setofferpopupopen] = useState(false)
    const [data, dispatchData] = useContext(DataMapping);
    const [okButtonPopUpContent, setOkButtonPopUpContent] = useState("");
    const [okButtonPopUpFlag, setOkButtonPopUpFlag] = useState(false)



    function applyNowFunction(types) {

        // var currentUserData = data?.parsedUserData[accountNumber];
        // let productName = data?.currentActiveData?.system === "las" ? "LAS" : data?.currentActiveData?.system === "ccod" ? "CCOD" : commonFunctionObject.getProductName(currentUserData);

        var offer = types;
        console.log(offer);
        console.log(offer.offerID)
        if (offer.serviceChange) {
            let requestJson = {
                "header": {
                    "authToken": data.authToken,
                },
                "body": {
                    "OfferId": offer.offerID,
                    "Product": offer.productName,
                }
            }
            dispatchData({
                type: STOREDATA,
                name: "loaderFlag",
                payload: true
            })
            CreditScoreServiceObject.offerToOpportunityService(requestJson).then((response) => {

                dispatchData({
                    type: STOREDATA,
                    name: "loaderFlag",
                    payload: false
                })
                setOkButtonPopUpContent("Thank you for reaching out. Thank You for applying to Tata Capital. Your loan application has been received and is being processed. Our Customer Service Representatives will contact you shortly.")
                setOkButtonPopUpFlag(true);
                getOffers();

            }).catch((error) => {
                dispatchData({
                    type: STOREDATA,
                    name: "loaderFlag",
                    payload: false
                })
                setFailurePopUpContent({
                    apiName: "",
                    message: "We are experiencing technical difficulty please try after sometime",
                    errorCode: error
                })

                setFailurePopUpModal(true);

            });

        }
        else {
            if (offer.jocataRedirection) {
                window.open(offer.applyNowBtn, '_blank');
                getOffers();
            } else {
                window.open(offer.applyNowBtn, '_blank');
            }
        }
    }

    function closepopup() {
        setofferpopupopen(false);
        dispatchData({
            name: "loaderFlag",
            type: STOREDATA,
            payload: false
        })
    }


    var [dynamicofferArr, setDynamicofferArr] = useState([]);
    var [staticofferArr, setStaticofferArr] = useState([]);
    var [staticPriorityObj, setstaticPriorityObj] = useState({})


    useEffect(() => {
        populateOffers();
    }, [dynamicOffers])

    const populateOffers = () => {
        dynamicofferArr = dynamicOffers.filter((item, index) => (
            item.serviceChange || item.jocataRedirection
        ))

        setDynamicofferArr(dynamicofferArr)
        var staticofferArray = dynamicOffers.filter((item, index) => (
            !(item.serviceChange || item.jocataRedirection)
        ))

        setStaticofferArr(staticofferArray)

        var priorObj = {}
        {
            staticofferArray.forEach((item, index) => {
                if (item.title.toLowerCase() === "personal loan") {
                    priorObj[0] = item
                }

                if (item.title.toLowerCase() === "business loan") {
                    priorObj[1] = item
                }

                if (item.title.toLowerCase() === "two wheeler loan") {
                    priorObj[2] = item
                }


                if (item.title.toLowerCase() === "used car loan") {
                    priorObj[3] = item
                }

                if (item.title.toLowerCase() === "home loan") {
                    priorObj[4] = item
                }
            })
        }
        setstaticPriorityObj(priorObj)
    }

    return (
        <> {offerpopopen ?
            <Modal>
                <div className='offer-modal-popup' >
                    <div className='description'>
                        <h2 className="heading">Thank you for reaching out</h2>
                        <p>
                            Thank You for applying to Tata Capital. Your loan application has been received and is
                            being processed. Our Customer Service Representatives will contact you shortly.
                        </p>
                    </div>
                    <div className='offer-popup-btn' onClick={closepopup}>
                        <a>OK</a>
                    </div>
                </div>
            </Modal>
            : null}

            {failurePopUpModal ? <FailurePopUp
                onClick={() => setFailurePopUpModal(false)}
                visible={failurePopUpModal}
                setFailureModalStat={setFailurePopUpModal}
                failurePopUpContent={failurePopUpContent}
            /> : null}
            {successPopUpModal ? <SuccessPopUp
                onClick={() => setSuccessPopUpModal(false)}
                visible={successPopUpModal}
                setSuccessModalStat={setSuccessPopUpModal}
                successPopUpContent={successPopUpContent}
            /> : null}
            {okButtonPopUpFlag ? <OkButtonPopUp
                onClick={() => setOkButtonPopUpFlag(false)}
                visible={okButtonPopUpFlag}
                setModalStat={setOkButtonPopUpFlag}
                Content={okButtonPopUpContent} /> : null}


            <div className="personalisedOffers-info-container-inner">
                <div className="personalisedOffers-head">
                    <div className="personalisedOffersIcon">
                        <img src="assets/images/personalised-offer-light-icon.svg" alt="personaliedOffersicon" />
                    </div>
                    {
                        dynamicofferArr && (dynamicofferArr.length > 0) ? <p className="personalisedOffers-heading">
                            Pre-Approved Offers
                        </p> :
                            <p className="personalisedOffers-heading">
                                More Offers
                            </p>
                    }
                    <div className="right-vector-icon">
                        <img src="assets/images/arrow-right-black.svg" alt="personaliedOffersicon" />
                    </div>
                </div>
                <div className="offers-container">
                    <div className="dynamic-offers-container">
                        {
                            dynamicofferArr && dynamicofferArr.map((types, index) => (
                                <div className={`${types.serviceChange || types.jocataRedirection ? "active" : ""} dynamicloan-offer`} key={index}>
                                    <div className="loan-details">
                                        <div className={`${types.serviceChange || types.jocataRedirection ? "tick-icon desktop tick-icon-arrow" : "tick-icon desktop"}`}>
                                            <img src={`${types.serviceChange || types.jocataRedirection ? "assets/images/background-arrow.svg" : ""}`} alt="" className={`${types.serviceChange || types.jocataRedirection ? "element" : ""}`} />
                                        </div>
                                        <div className="loaninfo-container">
                                            <div className={`${types.serviceChange || types.jocataRedirection ? "available-offers-flag" : null} offer-name-tick`}>
                                                <div className="loan-name">
                                                    <p>
                                                        {types.title}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="loan-sub-details">
                                                <p>
                                                    {types.description}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        (types.serviceChange || types.jocataRedirection) ? <Button
                                            className="personalised-offers-button green-button"
                                            onClick={() => { applyNowFunction(types) }
                                            }
                                        >
                                            Avail Now
                                            <img src="assets/images/arrow-right.svg" alt="arrow-right" style={{ width: "14px" }} />
                                        </Button> : <Button
                                            className="personalised-offers-button"
                                            onClick={() => {
                                                window.open(types.knowMore, "_blank");
                                            }}
                                        >
                                            Apply Now
                                            <img src="assets/images/arrow-right-blue.svg" alt="arrow-right" />
                                        </Button>
                                    }
                                </div>
                            ))
                        }
                    </div>

                    {
                        (dynamicofferArr && dynamicofferArr.length > 0) && (staticPriorityObj && Object.keys(staticPriorityObj).length > 0) ? <><div className="dynamicoffer"> </div><p className="staticoffer">Apply for other products</p></> : ""
                    }

                    <div className="static-offer-container">
                        {
                            staticPriorityObj && Object.keys(staticPriorityObj).map((types, index) => (
                                <div className={`${staticPriorityObj[types].serviceChange || staticPriorityObj[types].jocataRedirection ? "active" : ""} loan-offers`} key={index}>
                                    <div className="loan-details">
                                        <div className={`${staticPriorityObj[types].serviceChange || staticPriorityObj[types].jocataRedirection ? "tick-icon desktop tick-icon-arrow" : "tick-icon desktop"}`}>
                                            <img src={`${staticPriorityObj[types].serviceChange || staticPriorityObj[types].jocataRedirection ? "assets/images/background-arrow.svg" : ""}`} alt="" className={`${staticPriorityObj[types].serviceChange || staticPriorityObj[types].jocataRedirection ? "element" : ""}`} />
                                        </div>
                                        <div className="loaninfo-container">
                                            <div className={`${staticPriorityObj[types].serviceChange || staticPriorityObj[types].jocataRedirection ? "available-offers-flag" : null} offer-name-tick`}>
                                                <div className="loan-name">
                                                    <p>
                                                        {staticPriorityObj[types].title}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="loan-sub-details">
                                                <p>
                                                    {staticPriorityObj[types].description}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        (staticPriorityObj[types].serviceChange || staticPriorityObj[types].jocataRedirection) ? <Button
                                            className="personalised-offers-button green-button"
                                            onClick={() => { applyNowFunction(staticPriorityObj[types]) }
                                            }
                                        >
                                            Avail Now
                                            <img src="assets/images/arrow-right.svg" alt="arrow-right" style={{ width: "14px" }} />
                                        </Button> : <Button
                                            className="personalised-offers-button"
                                            onClick={() => {
                                                window.open(staticPriorityObj[types].knowMore, "_blank");
                                            }}
                                        >
                                            Apply Now
                                            <img src="assets/images/arrow-right-blue.svg" alt="arrow-right" />
                                        </Button>
                                    }
                                </div>
                            ))

                        }
                    </div>
                </div>
            </div>

        </>
    )
}

Offers.propTypes = {
    dynamicOffers: PropTypes.array,
    getOffers: PropTypes.func
}

export default Offers;